var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPreloader = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 64 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M58.4 55H5.6C3.1 55 1 53.5.2 51.1c-.7-2.4.1-4.8 2.2-6.2l24.9-16.5c.5-.3 1.1-.2 1.4.3s.2 1.1-.3 1.4L3.6 46.6c-1.6 1.1-1.8 2.7-1.4 3.9S3.7 53 5.6 53h52.7c1.9 0 3-1.3 3.4-2.5s.2-2.8-1.4-3.9L34.5 29.5c-.7-.4-1.2-1.2-1.1-2.1s.6-1.7 1.5-2c3.1-1.3 5.6-4.8 4.4-9.1-.7-2.4-2.7-4.3-5.2-5-2.4-.6-4.8-.2-6.7 1.3-1.9 1.4-3 3.6-3 5.9 0 .6-.5 1-1 1-.6 0-1-.5-1-1 0-3 1.4-5.7 3.8-7.5s5.5-2.4 8.5-1.6c3.1.8 5.7 3.3 6.6 6.4 1.4 4.8-1 9.6-5.6 11.5-.2.1-.2.2-.2.3s0 .2.1.3l25.9 17.2c2.1 1.4 3 3.8 2.2 6.2-.7 2.2-2.8 3.7-5.3 3.7"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPreloader);
export default ForwardRef;